export enum PixKeysErrorCode {
	CHAVE_JA_CADASTRADA = 'CHAVE_JA_CADASTRADA',
	CHAVE_VINCULADA_OUTRA_CONTA = 'CHAVE_VINCULADA_OUTRA_CONTA',
	CHAVE_VINCULADA_OUTRO_BANCO = 'CHAVE_VINCULADA_OUTRO_BANCO',
	CHAVE_VINCULADA_OUTRO_USUARIO = 'CHAVE_VINCULADA_OUTRO_USUARIO',
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/keys-error-code.enum.ts